// extracted by mini-css-extract-plugin
export var errorBanner = "_c8-2";
export var scroller = "_c8-0";
export var thinking = "_c8-1";
export var visuallyHidden = "_c8-3";